<template>
  <div class="mx-1">
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      fixed-header
      :sort-by="['usuario_nome']"
      class="font-resp-tabela table-full-screen"
      height="calc(100vh - 270px)"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="ml-n3">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Cadastro de Automatizados
          </v-toolbar-title>

          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 450px"
          ></v-text-field>

          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="dialog = true"
            >
            <v-icon left>mdi-plus</v-icon>
            Novo
          </v-btn
          >
        </v-toolbar>
      </template>

      <template v-slot:item.tipo_recorrencia="{ item }">
        {{ tipoRecorrencia(item.tipo_recorrencia) }}
      </template>

      <template v-slot:item.recorrencia="{ item }">
        <v-chip
          v-for="(recorrencia, index) in recorrencia(item.recorrencia)"
          :key="index"
          small
        >
          {{ recorrencia }}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon
          title="Editar Módulo"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          title="Remover Módulo"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="550"
    >
      <v-card>
        <v-card-title
          primary-title
          class="pl-3"
        >
          <v-btn
            color="#111"
            class="mr-3"
            icon
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span>{{ formTitle }}</span>
        </v-card-title>

        <v-divider class="mb-8"></v-divider>

        <v-card-text>
          <v-select
            v-model="editedItem.comprador_id"
            :items="selects.comprador.items"
            item-text="nome_completo"
            item-value="id"
            label="Compradores"
            outlined
            :error-messages="selectCompradorError"
            :disabled="this.editedIndex === -1 ? false : true"
            @input="$v.editedItem.comprador_id.$touch()"
            @blur="$v.editedItem.comprador_id.$touch()"
          ></v-select>

          <v-select
            v-model="editedItem.tarefa_id"
            :items="selects.tarefas.items"
            item-text="nome"
            item-value="id"
            label="Tarefas"
            outlined
            :error-messages="selectTarefaError"
            @input="$v.editedItem.tarefa_id.$touch()"
            @blur="$v.editedItem.tarefa_id.$touch()"
          ></v-select>

          <v-select
            v-model="editedItem.tipo_recorrencia"
            :items="selects.tipo_recorrencia.items"
            item-text="text"
            item-value="tipo_recorrencia"
            label="Periodicidade"
            outlined
            :error-messages="selectRecorrenciaError"
            @input="$v.editedItem.tipo_recorrencia.$touch()"
            @blur="$v.editedItem.tipo_recorrencia.$touch()"
          ></v-select>

          <v-select
            v-if="editedItem.tipo_recorrencia == 'semanal'"
            v-model="editedItem.recorrencia"
            :items="selects.recorrencia.items"
            multiple
            chips
            item-text="text"
            item-value="recorrencia"
            label="Dias da Recorrencia"
            outlined
            :error-messages="selectRecorrenciaSemanalError"
            @input="$v.editedItem.recorrencia.$touch()"
            @blur="$v.editedItem.recorrencia.$touch()"
          ></v-select>
        </v-card-text>


        <v-card-actions class="mt-n5">
          <div class="flex-grow-1"></div>
          <v-btn
            text
            @click="close"
          >
            Fechar
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AutomatizadorAPI from '../../../api/automatizadorTarefas';
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  data () {
    return {
      dialog: false,
      search: "",
      headers: [
        { text: "ID", value: "id"},
        { text: 'Usuário', value: 'comprador_nome_completo'},
        { text: 'Email', value: 'user_email'},
        { text: 'Tipo Recorrencia', value: 'tipo_recorrencia'},
        { text: 'Recorrência', value: 'recorrencia'},
        { text: 'Tarefa', value: 'tarefa_nome'},
        { text: "Ações", value: "action", sortable: false },
        { text: "", value: "action_delete", sortable: false },
      ],

      desserts: [],

      editedIndex: -1,

      editedItem: {
        comprador_id: null,
        tarefa_id: null,
        recorrencia: null,
        tipo_recorrencia: null
      },

      defaultItem: {
        comprador_id: null,
        tarefa_id: null,
        recorrencia: null,
        tipo_recorrencia: null
      },

      selects: {
        comprador: {
          items: []
        },
        tarefas: {
          items: []
        },
        tipo_recorrencia: {
          items: [
            { tipo_recorrencia: 'diario', text: "Diário" },
            { tipo_recorrencia: 'semanal', text: "Semanal" }
          ]
        },
        recorrencia:{
          items: [
            { recorrencia: '1', text: 'Segunda-Feira'},
            { recorrencia: '2', text: 'Terça-Feira'},
            { recorrencia: '3', text: 'Quarta-Feira'},
            { recorrencia: '4', text: 'Quinta-Feira'},
            { recorrencia: '5', text: 'Sexta-Feira'},
            { recorrencia: '6', text: 'Sabádo'},
            { recorrencia: '7', text: 'Domingo'}
          ]
        }
      },

      ativar_tab: 0
    }
  },

  validations : {
    editedItem: {
      comprador_id: {
        required
      },
      tarefa_id: {
        required
      },
      tipo_recorrencia: {
        required
      },
      recorrencia: {
        required: requiredIf(function() {
          if (this.editedItem.tipo_recorrencia == "semanal") {
            return true;
          } else {
            return false;
          }
        })
      }
    }
  },

  created() {
    this.initialize();
    this.buscarCompradorTarefas();
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  computed: {
    selectTarefaError() {
      const errors = [];
      if (!this.$v.editedItem.tarefa_id.$dirty) return errors;
      !this.$v.editedItem.tarefa_id.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    selectCompradorError() {
      const errors = [];
      if (!this.$v.editedItem.comprador_id.$dirty) return errors;
      !this.$v.editedItem.comprador_id.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    selectRecorrenciaError() {
      const errors = [];
      if (!this.$v.editedItem.tipo_recorrencia.$dirty) return errors;
      !this.$v.editedItem.tipo_recorrencia.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    selectRecorrenciaSemanalError() {
      const errors = [];
      if (!this.$v.editedItem.recorrencia.$dirty) return errors;
      !this.$v.editedItem.recorrencia.required && errors.push("Campo Obrigatório. Deve ser escolhido pelo menos um dia da semana");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova permissão de automatização" : "Editar permissão de automatização";
    },
  },

  methods: {
    tipoRecorrencia(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    recorrencia(string) {
      let val = [];
      if (string != null && string != '') {

        let newObject = JSON.parse(string);
        let newArray = Object.values(newObject).sort();

        newArray.forEach(dado => {
          switch (dado) {
            case "1":
              val.push("Seg")
              break
            case "2":
              val.push("Ter")
              break
            case "3":
              val.push("Qua")
              break
            case "4":
              val.push("Qui")
              break
            case "5":
              val.push("Sex")
              break
            case "6":
              val.push("Sab")
              break
            case "7":
              val.push("Dom")
              break
          }
        });
      }
      return val
    },
    buscarCompradorTarefas() {
      const headers = this.Helpers.iniciarRequisicao();
      this.$store.dispatch(
        "loading/addRequisicao",
        AutomatizadorAPI.buscarInfoCadastroAutomatizador(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.selects.comprador.items = response.data.usuariosCompradores;
            this.selects.tarefas.items = response.data.tarefasAutomatizadas;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();
      this.$store.dispatch(
        "loading/addRequisicao",
        AutomatizadorAPI.buscarAutomatizadores(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.automatizadores;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (item.tipo_recorrencia == 'semanal') {
        this.editedItem.recorrencia = JSON.parse(item.recorrencia);
      } else {
        this.editedItem.recorrencia = [];
      }

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      if (confirm("Deseja remover?")) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.editedItem;
        this.$store.dispatch(
          "loading/addRequisicao",
          AutomatizadorAPI.deleteAutomatizador(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.initialize();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.$v.$reset();
    },

    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.editedItem.tipo_recorrencia == 'diario') {
          this.editedItem.recorrencia = [];
        }
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.editedItem;
        this.$store.dispatch(
          "loading/addRequisicao",
          AutomatizadorAPI.saveNovaAutomatizacao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.initialize();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
        this.close();
      }
    }
  }
}
</script>
